import {isArray} from 'lodash';

import {isJSONNode, type JSONNode, type RecordStringUnknown} from './jsonTypes';

// This function takes a JSON object and returns a flat list of key-value pairs with the keys joined by dots.
// Example:
// {a: {b: 1, c: 2}, d: 3} -> {'a.b': 1, 'a.c': 2, 'd': 3}
export const flattenJSON = ({
  node,
  prefix = '',
}: {
  node: JSONNode;
  prefix?: string;
}): JSONNode => {
  const result: RecordStringUnknown = {};

  Object.entries(node).forEach(([key, value]) => {
    const newKey = prefix ? `${prefix}.${key}` : key;

    if (isJSONNode(value) && !isArray(value)) {
      Object.assign(result, flattenJSON({node: value, prefix: newKey}));
    } else {
      result[newKey] = value;
    }
  });

  return result;
};
